const isBrowser =
  typeof window !== 'undefined' && typeof document !== 'undefined'

export const initClarity = (projectId) => {
  if (!projectId || !isBrowser) return

  // Prevent duplicate script injection (Fast Refresh, multiple calls)
  if (document.querySelector(`script[src*="clarity.ms/tag/${projectId}"]`))
    return

  window.clarity =
    window.clarity ||
    Object.assign(
      (...args) => {
        ;(window.clarity.q = window.clarity.q || []).push(args)
      },
      { q: [] }
    )

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.clarity.ms/tag/${projectId}`
  ;(document.head || document.body || document.documentElement).appendChild(
    script
  )
}

const call = (...args) => {
  if (isBrowser && typeof window.clarity === 'function') window.clarity(...args)
}

/** Fire a named custom event (shows up in Clarity dashboards). */
export const clarityEvent = (eventName) => {
  if (!eventName) return
  call('event', eventName)
}

/** Attach a custom key/value tag to the session. */
export const clarityTag = (key, value) => {
  if (!key) return
  call('set', key, value)
}
